export default {
  tool: {
    playable: {
      template: 'テンプレート機能プロジェクト',
      editor: 'コンテンツ編集プロジェクト',
    },
    video: {
      editor: '動画プロジェクト',
    },
    screen: {
      recording: '録画プロジェクト',
    },
    customized: {
      creative: 'クリエイティブサービス',
    },
  },
}
